import { type CSSProperties, type ReactNode } from 'react';

type Variant = 'pass' | 'fail';

const RAYS = 8;

const COLORS: Record<Variant, { fill: string; mid: string }> = {
  pass: { fill: '#22c55e', mid: '#86efac' },
  fail: { fill: '#fe5e5e', mid: '#ffa5a5' },
};

function Glyph({ variant }: { variant: Variant }): ReactNode {
  if (variant === 'pass') {
    return (
      <path
        d="M15 25l6 6 12-12"
        fill="none"
        stroke="white"
        strokeWidth={4}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    );
  }
  return (
    <path
      d="M16 16l16 16M32 16L16 32"
      stroke="white"
      strokeWidth={4}
      strokeLinecap="round"
    />
  );
}

function BurstRays(): ReactNode {
  return (
    <div className="result-burst">
      {Array.from({ length: RAYS }).map((_, i) => (
        <span
          key={i}
          style={
            { ['--a' as string]: `${(360 / RAYS) * i}deg` } as CSSProperties
          }
        />
      ))}
    </div>
  );
}

export function ResultCheck({ variant }: { variant: Variant }): ReactNode {
  const c = COLORS[variant];
  const style = {
    ['--burst-color' as string]: c.fill,
    ['--burst-color-mid' as string]: c.mid,
  } as CSSProperties;
  return (
    <div className="relative h-9 w-9" style={style}>
      <svg className="animate-icon-pop h-9 w-9" viewBox="0 0 48 48">
        <circle cx={24} cy={24} r={24} fill={c.fill} />
        <Glyph variant={variant} />
      </svg>
      <BurstRays />
    </div>
  );
}
